export default [
  {
    title: 'Accounts',
    icon: 'DollarSignIcon',
    children: [
      {
        title: 'Charts of Accounts',
        route: 'charts-of-accounts-list',
      },
      {
        title: 'Transfer',
        route: 'transfer',
      },
      {
        title: 'Funds',
        route: 'funds',
      },
      {
        title: 'Journal Voucher',
        route: 'journal-entries',
      },
      {
        title: 'Budget',
        route: 'budget-list',
      },
      {
        title: 'Meter Readings',
        route: 'meter-readings-list',
      },
      {
        title: 'Fuel Vouchers',
        route: 'fuel-vouchers-list',
      },
      {
        title: 'Routes',
        route: 'accounts-routes-list',
      },
      {
        title: 'Receipt/Credit Voucher',
        route: 'receipt-credit-voucher',
      },
      {
        title: 'Payments/Debit Voucher',
        route: 'payments-debit-voucher',
      },
      {
        title: 'Expense',
        route: 'expense-entries',
      },
      {
        title: 'Monthly Payment Schedules',
        route: 'monthly-payment-schedules-list',
      },
      {
        title: 'Due Receivable Schedules',
        route: 'due-receivable-schedules-list',
      },
      {
        title: 'Cheque Printing',
        route: 'cheque-list',
      },
      {
        title: 'Post Dated Cheques',
        route: 'post-dated-cheques-list',
      },
      {
        title: 'Requisitions',
        route: 'requisition-list',
      },
      {
        title: 'Requisition Quotations',
        route: 'requisition-quotation',
      },
      {
        title: 'Physical Cash Verification',
        route: 'physical-cash-verification-list',
      },
      {
        title: 'Settings',
        route: 'account-settings',
      },
    ],
  },
];
